export default "__VITE_ASSET__94dea462__"